import { resolveLandingPage } from '../utils/landingPage';
import { useDomain } from './useDomain';
import { useLanguage } from './useLanguage';

export const useLandingPage = (path = '') => {
    const domain = useDomain();
    const language = useLanguage();

    return `${resolveLandingPage(language, domain)}${path}`;
};
